<template>
  <DashboardUser v-if="usertype === '1'" />
  <DashboardRenter v-else-if="usertype === '2'" />
</template>

<script>

import DashboardUser from "@/components/dashboard/user";
import DashboardRenter from "@/components/dashboard/renter";

export default {
  name: 'Dashboard',
  computed: {
    usertype() {
      return localStorage.getItem("user-type")
    }
  },
  components: {
    DashboardRenter,
    DashboardUser
  }
}
</script>
<style scoped>
</style>
